import { Injectable, signal } from '@angular/core';
import { JobLocation, makeBlankTenantView, makeNewRequest, ReasonRequest, ReportedLocation, RequestListItem, TenantView, TenantWorkOrderRequest, WorkOrderType } from './models';
import { JSONResponse, UserService } from './user.service';

@Injectable({
	providedIn: 'root'
})
export class WorkRequestService {
	public newRequest = signal<TenantWorkOrderRequest>(makeNewRequest( makeBlankTenantView()));

	public requestList = signal< RequestListItem[]>([]);

	public newRequestImages = signal<File[]>([]);


	//JobLocation
	//ReasonRequest
	//ReportedLocation
	//WorkOrderType

	public JobLocations = signal<JobLocation[]>([]);
	public ReasonRequests = signal<ReasonRequest[]>([]);
	public ReportedLocations = signal<ReportedLocation[]>([]);


	public WorkOrderTypes = signal<WorkOrderType[]>([
		{ id: 1, type_name: 'Single Property', type_namej: 'シングル物件', status: 1, added_on: new Date('2019-07-12T18:34:54') },
		{ id: 2, type_name: 'Multiple Property', type_namej: '複数物件', status: 1, added_on: new Date('2019-07-12T18:34:54') }
	]);

	constructor( protected _userService: UserService  ) { }

	
	async getMyWorkRequests( tenantId: number ): Promise<JSONResponse> {
		//fetch the work requests for this tenant from the server
		return fetch('https://delta.mycapx.com/Tenant_Services_Controller/getTenantWorkRequests', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			credentials: 'include', // <-- correct usagea
			body: JSON.stringify({ tenant_id: tenantId })
		}).then(res => res.json())
		.then((data: JSONResponse) => {
			console.log('Get My Work Requests Response Data:', data);
			if (data.success) {
				this.requestList.update( (prev) => {
					data.data = (data.data as RequestListItem[]).map((req) => {
						//map work_request_status_name based on language
						if( this._userService.currentTennant().Language == 1 ) {
							req.Request.Work_request_status_name = req.Request.Work_request_status_name_en;
							req.Request.Work_request_status_description = req.Request.Work_request_status_description_en;
							req.Request.Job_location_name = req.Request.Job_location_name_e;
						} else {
							req.Request.Work_request_status_name = req.Request.Work_request_status_name_jp;
							req.Request.Work_request_status_description = req.Request.Work_request_status_description_jp;
							req.Request.Job_location_name = req.Request.Job_location_name_j;
						}
						return req;
					});
					return data.data as RequestListItem[];
				});
				return data;
			} else {
				this.requestList.set([]);
			}
			return data;
		})
		.catch((error) => {
			console.log('Error fetching work requests:', error);
			return { success: false, data: null, error: 'Network error' };
		});
	}

	async loadRequestOptions(language: number, isTennant: boolean): Promise<JSONResponse> {
		console.log('Loading request options with language:', language);
		try {
			let [jobLocs, reasonReqs, reportedLocs] = await Promise.all([
				fetch('https://delta.mycapx.com/Tenant_Services_Controller/getJobLocationOptions', {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					},
					credentials: 'include', // <-- correct usage
				}).then(res => res.json()),
				fetch('https://delta.mycapx.com/Tenant_Services_Controller/getReasonRequestOptions', {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					},
					credentials: 'include', // <-- correct usage
				}).then(res => res.json()),
				fetch('https://delta.mycapx.com/Tenant_Services_Controller/getReportedLocationOptions', {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					},
					credentials: 'include', // <-- correct usage
				}).then(res => res.json())
			]);

			console.log('Job Locations:', jobLocs);
			console.log('Reason Requests:', reasonReqs);
			console.log('Reported Locations:', reportedLocs);

			if (jobLocs.success && Array.isArray(jobLocs.data)) {

				//map LABEL field , if language is 1 use location_name_e, if 2 use location_name_j
				jobLocs.data = jobLocs.data.map((loc: JobLocation) => {
					return { ...loc, LABEL: language == 1 ? loc.location_name_e : loc.location_name_j };
				});
				this.JobLocations.set(jobLocs.data as JobLocation[]);
			} else {
				this.JobLocations.set([]);
			}

			if (reasonReqs.success && Array.isArray(reasonReqs.data)) {
				//map LABEL field , if language is 1 use opt_name, if 2 use opt_namej
				reasonReqs.data = reasonReqs.data.map((req: ReasonRequest) => {
					return { ...req, LABEL: language == 1 ? req.opt_name : req.opt_namej };
				});
				// if tennant, tennant only reasons
				if (isTennant) {
					reasonReqs.data = reasonReqs.data.filter((req: ReasonRequest) => {
						if (req.opt_name == 'On-demand Repair Exterior' || req.opt_name == 'On-demand Repair Interior') {
							return true;
						}
						return false;
					});
				}
				this.ReasonRequests.set(reasonReqs.data as ReasonRequest[]);
			} else {
				this.ReasonRequests.set([]);
			}

			if (reportedLocs.success && Array.isArray(reportedLocs.data)) {
				//map LABEL field , if language is 1 use opt_name, if 2 use opt_namej
				reportedLocs.data = reportedLocs.data.map((loc: ReportedLocation) => {
					return { ...loc, LABEL: language == 1 ? loc.opt_name : loc.opt_namej };
				});
				this.ReportedLocations.set(reportedLocs.data as ReportedLocation[]);
			} else {
				this.ReportedLocations.set([]);
			}

			
			return { success: true, data: null, error: '' };
		} catch (error) {
			console.error('Error loading request options:', error);
			return { success: false, data: null, error: 'Failed to load request options' };
		}
	}

	resetNewRequest( tenant: TenantView) {
		if(!tenant){
			tenant = makeBlankTenantView();
		}
		this.newRequest.set(makeNewRequest(tenant));
		this.newRequestImages.update( (prev ) => {
			return [];
		});
	}

	submitNewRequest(): Promise<JSONResponse> {
		//need to send two things in one c : one is a json object of newRequest, the other is all the files in newRequestImages
		//use FormData to send both
		const formData = new FormData();
		formData.append('request', JSON.stringify(this.newRequest()));
		this.newRequestImages().forEach((file, index) => {
			formData.append('file' + index, file);
		});

		return fetch('https://delta.mycapx.com/Tenant_Services_Controller/submitWorkOrderRequest', {
			method: 'POST',
			credentials: 'include', // <-- correct usage
			body: formData,
		}).then(res => res.json())
		.then((data: JSONResponse) => {
			console.log('Submit Request Response Data:', data);
			return data;
		})
		.catch((error) => {
			console.log('Error submitting request:', error);
			return { success: false, data: null, error: 'Network error' };
		});

	}

}


/*
submitNewRequest(): Promise<JSONResponse> {
		//need to send two things in one c : one is a json object of newRequest, the other is all the files in newRequestImages
		//use FormData to send both
		const formData = new FormData();
		formData.append('request', JSON.stringify(this.newRequest()));
		this.newRequestImages().forEach((file, index) => {
			formData.append('file' + index, file);
		});

		return fetch('https://delta.mycapx.com/Tenant_Services_Controller/submitWorkOrderRequest', {
			method: 'POST',
			credentials: 'include', // <-- correct usage
			body: formData,
		}).then(res => res.json())
		.then((data: JSONResponse) => {
			console.log('Submit Request Response Data:', data);
			return data;
		})
		.catch((error) => {
			console.log('Error submitting request:', error);
			return { success: false, data: null, error: 'Network error' };
		});

	}

	export type TenantWorkOrderRequest = {
	Tenant_id: number;
	Building_id: number;
	Unit_id: number;
	Work_order_type_id: number;
	Job_location_id: number;
	Reason_for_request_id: number;
	Reported_location_id: number;
	Emergency: boolean;
	Last_name: string;
	Street_address: string;
	City: string;
	Region: string;
	Job_location_name: string;
	Reason_for_request_name: string;
	Reported_location_name: string;
	Description: string;
	Status: string;
	Work_order_id: number;
	
}

*/